// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"750809aa","175":"1f7dc4da","377":"05adedc1","436":"1ee28c58","787":"627756db"}[chunkId] + ".chunk.js";
};